export default __webpack_public_path__ + "static/article-renovation-smart-hacks-3a3624c5aa335ce7a45f1a3fa2f0e995.jpg";